import {Injectable} from '@angular/core';
import {CommonService} from "../../../shared/services/common.service";


@Injectable({
  providedIn: 'root',
})
export class ParticipantGroupsListService {
  constructor(
    private commonServices: CommonService
  ) {
  }


}
